import { render, staticRenderFns } from "./trainingModuleFormBuilder.vue?vue&type=template&id=3bd71806"
import script from "./trainingModuleFormBuilder.vue?vue&type=script&lang=js"
export * from "./trainingModuleFormBuilder.vue?vue&type=script&lang=js"
import style0 from "./trainingModuleFormBuilder.vue?vue&type=style&index=0&id=3bd71806&prod&lang=css"
import style1 from "./trainingModuleFormBuilder.vue?vue&type=style&index=1&id=3bd71806&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports